<template>
    <div class="audio-player-container">
        <div class="cta-box" @click="handleCta">
            <span class="icon-play" v-if="showPlay"></span>
            <span class="icon-pause" v-if="showPause"></span>
            <div class="lds-ring" v-if="loading">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="controlbar" @click.stop="changeSeek">
                <div class="progress" :style="'width: '+progress+'%'"></div>
            </div>

        </div>
        <div class="description">
            <slot></slot>
            <div class="duration" v-html="duration"></div>
        </div>
    </div>
</template>

<script>
    import {Howl, Howler} from "howler";

    export default {
        props: {
            file: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                soundInstance: null,
                play: false,
                progress: 0,
                loading: false,
                duration: null,
                durationSeconds: null,
                setInterval: null
            };
        },
        computed: {
            showPlay() {
                if (this.loading) {
                    return false
                }
                return !this.play
            },
            showPause() {
                if (this.loading) {
                    return false
                }
                return this.play
            }
        },
        methods: {
            handleCta() {
                if (this.soundInstance === null) {
                    this.initHowl()
                    return
                }

                if (this.play) {
                    this.soundInstance.pause()
                } else {
                    this.soundInstance.play()
                }


            },
            initHowl() {
                this.loading = true
                this.soundInstance = new Howl({
                    src: this.file,
                    onload: () => {
                        this.soundInstance.play();
                        this.loading = false
                        this.durationSeconds = this.soundInstance.duration()
                        this.duration = this.getFormatedDuration(this.durationSeconds)
                    },
                    onend: () => {
                        this.soundInstance.pause()
                        this.soundInstance.seek(0);
                        this.progress = 0
                    },
                    onpause: () => {
                        this.play = false
                        clearInterval(this.setInterval);
                    },
                    onplay: () => {

                        if (Howler._howls.length > 1) {
                            Howler._howls.forEach((element) => {
                                if (element !== this.soundInstance) {
                                    element.pause()
                                }
                            });

                        }
                        this.play = true
                        this.initProgessBar()
                    },
                });


            },
            initProgessBar() {
                this.setInterval = setInterval(() => {
                    this.progress = Math.ceil((this.soundInstance.seek() * 100) / this.durationSeconds)
                }, 200)
            },
            getFormatedDuration(fullSeconds) {

                let minutes = Math.floor(fullSeconds / 60)
                let secondes = Math.floor(fullSeconds - (minutes * 60))

                let minuteString = minutes ? minutes + " min " : ""

                return minuteString + secondes + " s"
            },
            changeSeek(event) {
                if (this.soundInstance === null) {
                    this.initHowl()
                    return
                }

                let targetElement = event.target

                if (event.target.className === "progress"){
                    targetElement = event.target.parentElement
                }

                let percent = Math.floor((event.offsetX * 100) / targetElement.clientWidth)
                this.progress = percent
                let targetDuration = (this.durationSeconds * percent) / 100
                this.soundInstance.seek(targetDuration);
            }
        },
        mounted() {
        },
        destroyed() {
        }
    };
</script>
